import { graphql } from 'graphql-schema';

type PendingReservation = {
  bookingId: string;
  rentalId: string;
  selectedTimeSlotIds: string[];
  numGuestsEstimate: number;
  password?: string;
};

export type PriceModifiers = {
  donationCents?: number;
  promoCodeStr?: string;
  creditCents?: number;
};

export type Agreements = {
  policyAgreed: boolean;
  waiverAgreed: boolean;
};

export type BookRentalsInput = {
  pendingReservations: Array<PendingReservation>;
} & PriceModifiers &
  Agreements;

export const BOOK_RENTALS = graphql(`
  mutation BookRentals($input: BookRentalsInput!) {
    bookRentals(input: $input) {
      rentalReservations {
        _id
        deep_link
      }
    }
  }
`);

export type JoinReservationInput = {
  reservationId: string;
  password?: string;
} & Pick<PriceModifiers, 'donationCents'> &
  Agreements;

export const JOIN_RESERVATION = graphql(`
  mutation JoinReservation($input: JoinReservationInput!) {
    joinReservation(input: $input) {
      _id
    }
  }
`);
